export default __webpack_public_path__ + "static/media/invite-bee.80ed3214.png";